import React from 'react'
import Header from '../../Layout/Header/Index'
import Banner from './compoenet/Banner/Index'
import Footer from '../../Layout/Footer/Index'
import IntroduceFreelancer from './compoenet/IntroduceFreelnacer/Index';
import { Helmet } from 'react-helmet'
import Blogs from './compoenet/ourBlog/Blogs'
import BecomeAfreelancer from './compoenet/beaomeafreelancer/BecomeAfreelancer'
import ChatBotIndex from '../ChatBot/ChatBot'
// import "./homepagemain.scss"
import ChatBotFreelancer from '../ChatBot/ChatBotFreelancer'
import ChatBotRecruiter from '../ChatBot/ChatBotRecruiter'
import FAQS from '../faqs/FAQS'
import ExploreTopJobAbdProject from './compoenet/exploretopjobandproject/ExploreTopJobAbdProject'
import FindHireTalent from './compoenet/findhiretalent/FindHireTalent'
import HireMadeEasy from './compoenet/hiremadeeasy/HireMadeEasy'
import FindByCard from './compoenet/findbycard/FindByCard'
import ExploreToService from './compoenet/exploretoservice/ExploreToService'
import ExploreTopTalent from './compoenet/exploretoptalent/ExploreTopTalent'
// import HeaderMain from '../../Layout/Header/HeaderMain';
// import ReferEarn from '../refertoearnnew/ReferEarn';
// import ExploreTopJobByCategory from './compoenet/exploreTopjobBycategory/ExploreTopJobByCategory'


const Home = () => {
  const client_Id = localStorage.getItem("client_Id");
  const recuiter_Id = localStorage.getItem("recuiter_Id");


  return (
    <>
      <Helmet>

        <title>Find or Hire Nearby Freelancers in India</title>

        <meta name="description" content={`Discover top freelancers in India with Nearby Freelancers. Hire experts for quality services and get your projects done efficiently!`} />
      </Helmet>
      <Header />
     
      {/* <HeaderMain /> */}
      <Banner />
      <div style={{ background: "white" }} className="home-container">
        <FindByCard />
        <ExploreToService />
        {client_Id ? <BecomeAfreelancer /> : recuiter_Id ? <BecomeAfreelancer /> : null}
        {/* {client_Id ? <ExploreTopJobByCategory/>:null} */}
        {recuiter_Id ? <ExploreTopTalent /> : client_Id ? null : <ExploreTopTalent />}
        {client_Id ? null : recuiter_Id ? null : <HireMadeEasy />}
        {client_Id ? null : recuiter_Id ? <FindHireTalent /> : <FindHireTalent />}
        <ExploreTopJobAbdProject />
        <IntroduceFreelancer />
      </div>
      {client_Id ?
        <ChatBotFreelancer />
        : recuiter_Id ?
          <ChatBotRecruiter />
          : (
            <ChatBotIndex />
          )}
      <FAQS />
      {/* <Blogs /> */}
      <Footer />
    </>
  )
}

export default Home